import { Marker, Popup } from 'react-map-gl/mapbox';
import { useMap } from 'react-map-gl/mapbox';
import { useState } from 'react';
import CoordinatesLink from '../Base/CoordinatesLink';
import ClockLines from './ClockLines';
import CameraFOV from './CameraFOV';
import './CameraMarker.css';

import cameraIcon from '../../../assets/camera-marker.png';
import cameraImage from '../../../assets/camera-ptz.png';

const CameraMarker = ({ data, isActive, onActivate, onDeactivate }) => {
  const { current: map } = useMap();

  const [showClockLines, setShowClockLines] = useState(false);

  const id = `camera-${data.cameraId ?? data.name}`;

  return (
    <>
      <Marker
        longitude={data.location.longitude}
        latitude={data.location.latitude}
        className="camera-marker"
      >
        <img
          onClick={(e) => {
            e.stopPropagation();
            map.easeTo({
              center: [data.location.longitude, data.location.latitude],
              offset: [0, -100],
              duration: 500,
            });
            onActivate();
          }}
          src={cameraIcon}
          alt="Camera"
          className="camera-marker-image"
        />

        {isActive && (
          <Popup
            longitude={data.location.longitude}
            latitude={data.location.latitude}
            onClose={onDeactivate}
            closeOnClick={true}
            anchor="top"
          >
            <div style={{ fontFamily: "'Inter', sans-serif", maxWidth: '200px', minWidth: '150px' }}>
              <h3 style={{ marginBottom: '4px', fontSize: '14px' }}>Cámara</h3>
              <img
                src={cameraImage}
                alt="Camera PTZ"
                style={{
                  width: '60px',
                  height: '60px',
                  marginBottom: '10px',
                  float: 'right',
                  marginRight: '10px',
                }}
              />
              <span style={{ fontSize: '28px' }}>{data.name}</span>

              <CoordinatesLink
                latitude={data.location.latitude}
                longitude={data.location.longitude}
              />

              {/* Checkbox para clockLines */}
              <div style={{ marginTop: '10px' }}>
                <label>
                  <input
                    type="checkbox"
                    checked={showClockLines}
                    onChange={() => setShowClockLines(!showClockLines)}
                  />
                  Mostrar líneas horarias
                </label>
              </div>
            </div>
          </Popup>
        )}
      </Marker>

      {/* ClockLines independiente para esta cámara */}
      <ClockLines
        id={id}
        mapRef={map}
        showClockLines={showClockLines}
        center={[data.location.longitude, data.location.latitude]}
      />

      <CameraFOV
        id={data.cameraId}
        cameraId={data.cameraId}
        fovColor={data.fovColor || '#000000'}
        center={[data.location.longitude, data.location.latitude]}
      />

    </>
  );
};

export default CameraMarker;
